import { Flex, Box, BoxProps, BoxType } from 'reflexbox';
import styled from 'styled-components';

import { StarIcon, StarEmptyIcon } from '@treams/treams-icons';
import { ComponentProps } from 'react';

const Star = styled(Box)`
	flex-grow: 0;
	flex-shrink: 0;

	svg {
		display: block;

		path {
			fill: #f7b500;
		}
	}
`;

export function Stars(props: BoxProps & { stars: number }) {
	const { stars, ...rest } = props;

	return (
		<Flex {...(rest as ComponentProps<BoxType>)}>
			{Array(5)
				.fill(null)
				.map((_, index) => {
					return (
						<Star key={index} width={24}>
							{index < stars ? <StarIcon /> : <StarEmptyIcon />}
						</Star>
					);
				})}
		</Flex>
	);
}
